export enum UserStorageTypes {
  xsolla = 'xsolla',
  firebase = 'firebase',
  playfab = 'playfab',
  custom = 'custom'
}

export enum CustomStorageFieldTypes {
  login_url = 'login_url',
  registration_url = 'registration_url',
  social_url = 'social_url',
  password_reset_url = 'password_reset_url',
  email_change_url = 'email_change_url',
  passwordless_registration_url = 'passwordless_registration_url',
  refresh_token_url = 'refresh_token_url'
}

export const StorageFieldLinks = {
  [CustomStorageFieldTypes.login_url]:
    'https://developers.xsolla.com/doc/login/user-data-storage/custom-storage/#login_how_to_users_storage_custom_authentication',
  [CustomStorageFieldTypes.registration_url]:
    'https://developers.xsolla.com/doc/login/user-data-storage/custom-storage/#login_how_to_users_storage_custom_registration',
  [CustomStorageFieldTypes.password_reset_url]:
    'https://developers.xsolla.com/doc/login/user-data-storage/custom-storage/#login_how_to_users_storage_custom_password_reset',
  [CustomStorageFieldTypes.email_change_url]:
    'https://developers.xsolla.com/doc/login/user-data-storage/custom-storage#login_how_to_users_storage_custom_change_email',
  [CustomStorageFieldTypes.passwordless_registration_url]:
    'https://developers.xsolla.com/doc/login/user-data-storage/custom-storage/#login_how_to_users_storage_custom_passwordless_authentication',
  [CustomStorageFieldTypes.social_url]:
    'https://developers.xsolla.com/doc/login/user-data-storage/custom-storage/#login_how_to_users_storage_custom_social_authentication',
  [CustomStorageFieldTypes.refresh_token_url]:
    'https://developers.xsolla.com/doc/login/user-data-storage/custom-storage/#login_how_to_users_storage_custom_refresh_token',
  playfab_title_id:
    'https://learn.microsoft.com/en-us/gaming/playfab/live-service-management/gamemanager/reference#about-title-settings',
  firebase_apikey: 'https://firebase.google.com/docs/projects/api-keys'
};

export type DataStorageFormValues = {
  users_storage?: UserStorageTypes;
  playfab_title_id?: string | null;
  firebase_apikey?: string | null;
  [CustomStorageFieldTypes.login_url]?: string;
  [CustomStorageFieldTypes.registration_url]?: string | null;
  [CustomStorageFieldTypes.password_reset_url]?: string | null;
  [CustomStorageFieldTypes.email_change_url]?: string | null;
  [CustomStorageFieldTypes.passwordless_registration_url]?: string | null;
  [CustomStorageFieldTypes.social_url]?: string | null;
  [CustomStorageFieldTypes.refresh_token_url]?: string | null;
  add_social_access_token?: boolean;
};

export const MappingFieldsList = [
  'mapping_birthday',
  'mapping_first_name',
  'mapping_gender',
  'mapping_last_name',
  'mapping_nickname',
  'mapping_server_custom_id'
];
